<div class="general-info-card">
    <div class="header-row">
        <h3>Trip Information</h3>
    </div>

    <div class="info-list">
        <div class="info-row">
            <div class="label">Vehicle Temperature</div>
            <div class="sep">:</div>
            <div class="value">
                {{ placement?.venhicleTempeature ?? venhicleTempeature ?? '-' }}
            </div>
        </div>
        <div class="info-row">
            <div class="label">Vehicle Humidity</div>
            <div class="sep">:</div>
            <div class="value">
                {{ placement?.venhicleHumidity ?? venhicleHumidity ?? '-' }}
            </div>
        </div>
        <div class="info-row">
            <div class="label">Stopping Time</div>
            <div class="sep">:</div>
            <div class="value">
                {{ placement?.stoppingTime ?? stoppingTime ?? '-' }}
            </div>
        </div>
        <div class="info-row">
            <div class="label">Chicks Trip Time</div>
            <div class="sep">:</div>
            <div class="value">
                From Hatchery to farm
                {{
                    placement?.chicksTripTime || chicksTripTime
                        | date: 'shortTime'
                }}
            </div>
        </div>
    </div>
</div>
